<template>
  <!-- 关于我们 -->
  <div style="margin-top: 2px; height: auto;">
    <!-- <img class="	" src="../../assets/images/About/xinbannner.png" style="margin-top: 56px;" width="100%"> -->
    <template>
      <el-carousel :interval="4000" style="margin-top: 80px;" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="item in imagesbox" :key="item.id">
          <img :style="ifnull(item.toUrl) ? 'cursor: pointer' : ''" @click="isLetgodeta(item)"
            :src="downloadUrl + item.imgUrl" class="image">
        </el-carousel-item>
      </el-carousel>
    </template>

    <div class="zitcolor" style="background: #F9F9F9;" >
      <div style="width: 1200px;margin: 0 auto; padding-top: 50px;">
        <h1 class="wow bounceInLeft" data-wow-duration='1s'>互联网共享软件工厂</h1>
        <p class="wow bounceInRight" data-wow-duration='1s' style="color:#666;font-size: 16px; text-align: center;">Kepler
          Software Factory Platform</p>
        <div class="official wow pulse esofficial" >
          <p>
            华腾软件产业有限公司从事电子政务、企业管理、电子商务和智慧城市等软件系统的程序自动生成研究启航于1998年，历经20多年的技术研究和探索，成功地研发出编程自动化技术Kepler
            PAT（即无代码编程技术），并以此技术为核心创建了互联网共享软件工厂，对软件开发进行了颠覆性创新，开启了软件产业互联网新时代。软件工厂集成了互联网、云计算、区块链、人工智能和大数据等先进信息技术，具有两大核心创新：
          </p>
          <p>
            第一是技术创新：我们的编程自动化技术Kepler
            PAP是真正的无代码编程技术，通过可视化拖拽软件系统元素并配置元素属性，实现非专业人员也能够快速搭建软件系统并自动生成适配多端设备的软件源代码。针对软件系统中复杂的业务逻辑，Kepler
            PAP通过逻辑建模既能可视化处理判断、循环、转换、级联关联、统计计算、数据校验、数据库等数据逻辑，又可改变页面元素结构、显示/隐藏的页面逻辑。
          </p>
          <p>
            第二是模式创新：互联网共享软件工厂将充分整合社会劳动力资源，培养海量建模工程师在线提供服务，根据项目交付时间的需要可以随时组建几十人、几百人、甚至几千人的项目团队。用户还可以通过软件工厂将自己的创意和想法模型化，分享至淘软件平台中，实现模型与数据共享，并可以自主选择模型收费方式，形成具有良性循环的模型共享生态圈。软件工厂彻底解决了目前软件开发中面临的需求变化快、交付时间长、人才流动大、迭代升级难、成本特别高等一系列难题。
          </p>
          <p>
            互联网共享软件工厂将发展成为一个具有百万级工程师、千万级会员、亿万级用户的软件开发、软件交易和软件应用生态圈，实现不论何时、不论何地、不论人数的异步协同开发，成为一个面向全世界提供软件定制服务的超级软件工厂。
          </p>
        </div>
      </div>

      <div class="neirdier">
        <el-row style="width: 1200px;margin: 0 auto;">
          <el-col :span="8" :offset="2" class="wow slideInLeft" data-wow-duration='1s'>
            <div style="height: 200px;">
              <h2>24+</h2>
              <p>自1998年实现第一套程序自动生成系统，拥有</p>
              <p>20多年的软件系统自动生成研究、开发经验</p>
            </div>
          </el-col>
          <el-col :span="8" :offset="4" class="wow slideInRight" data-wow-duration='1s'>
            <div style="height: 200px;">
              <h2>98%</h2>
              <p>已实现98%以上程序代码自动生成，使大量的</p>
              <p>非计算机软件人员能够从事管理系统软件开发</p>
            </div>
          </el-col>
        </el-row>
        <el-row style="width: 1200px;margin: 0 auto;">
          <el-col :span="8" :offset="2" class="wow slideInLeft" data-wow-duration='1s'>
            <div style="height: 200px;">
              <h2>2</h2>
              <p>互联网共享软件工厂实现了2大创新：</p>
              <p>技术创新和模式创新</p>
            </div>
          </el-col>
          <el-col :span="8" :offset="4" class="wow slideInRight" data-wow-duration='1s'>
            <div style="height: 200px;">
              <h2>10,000,000+</h2>
              <p>成为千万级流水线认证工程师的超级管理</p>
              <p>软件开发平台</p>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
    <div class="zitcolor" style="height: 757px;padding-top: 90px;background: #fff;">
      <div style="width: 1200px; margin: 0 auto;">
        <h1 class=" wow bounceIn">业务范围</h1>
        <p class="wow bounceIn" style="color:#666;font-size: 16px;">Scope of business</p>
        <div class="bancreh wow fadeInDownBig" style="visibility: visible">
          <div class="bancreh-1">
            <img class="imgtransion" src="../../assets/images/About/hangye.png" style="margin-top: 54px;">
            <p class="zitdxs">场景解决方案</p>
            <div class="aboustdw">
              <p>基于编程机器人可视化建模</p>
              <p>高效构建全方面场景应用开发</p>
            </div>
          </div>
          <div class="bancreh-2 wow  fadeInUpBig" data-wow-duration='1s'>
            <img class="imgtransion" src="../../assets/images/About/jiejue.png" style="margin-top: 54px;">
            <p class="zitdxs">行业解决方案</p>
            <div class="aboustdw">
              <p>覆盖各行各业提供整套解决方案 </p>
              <p>助力政府和企业实现数字化转型</p>
            </div>
          </div>
          <div class="bancreh-3 wow fadeInDownBig">
            <img class="imgtransion" src="../../assets/images/About/shengtai.png" style="margin-top: 54px;">
            <p class="zitdxs">生态解决方案</p>
            <div class="aboustdw">
              <p>完整覆盖软件全生命周期的软件服务</p>
              <p>打造软件服务新生态</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zitcolor" style="height: 848px;background: #F9F9F9;padding-top: 90px;">
      <div style="width: 1200px; margin: 0px auto;">
        <h1>平台特色</h1>
        <p style="color:#666;font-size: 16px;">Platform features</p>
        <el-row>
          <el-col :span="10" class=" ">
            <img src="../../assets/images/About/10.png">
          </el-col>
          <el-col :span="12" :offset="2" class="wow bounceInRight">
            <div class="Platform">
              <el-row class="Platform-1">
                <el-col :span="7">
                  <h3>通用·低成本</h3>
                </el-col>
                <el-col :span="17" style="margin-top: 20px;">
                  <p>拖拽方式构建应用程序，非开发人员可参与，降低人力成本和沟通成本</p>
                </el-col>
              </el-row>
              <el-row class="Platform-1">
                <el-col :span="7">
                  <h3>联通·高效率</h3>
                </el-col>
                <el-col :span="17" style="margin-top: 20px;">
                  <p>支持跨平台部署，打通上下游数据；按需开发，提升10倍以上的开发效率</p>
                </el-col>
              </el-row>
              <el-row class="Platform-1">
                <el-col :span="7">
                  <h3>灵活·强稳定</h3>
                </el-col>
                <el-col :span="17" style="margin-top: 20px;">
                  <p>设计灵活应对快速开发和敏捷变更；代码结构化程度高，更容易维护</p>
                </el-col>
              </el-row>
              <el-row class="Platform-1">
                <el-col :span="7">
                  <h3>生态·高标准</h3>
                </el-col>
                <el-col :span="17" style="margin-top: 20px;">
                  <p>100%源代码支持二开，提升应用系统的契合度；源码生成统一规范，符合行业标准</p>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="zitcolor" style="background: #fff;height: 777px;">
      <div style="width: 1200px; margin: 0 auto;">
        <div style="justify-content: space-between; display: flex; width: 100%;">
          <div class=" ">
            <p class="gtfzys">共享</p>
            <img class="imgtransion" src="../../assets/images/About/xingx.png">
          </div>
          <div class=" ">
            <p class="gtfzys">共赢</p>
            <img class="imgtransion" src="../../assets/images/About/xingy.png">
          </div>
          <div :span="6" class="">
            <p class="gtfzys">共发展</p>
            <img class="imgtransion" src="../../assets/images/About/xingfz.png">
          </div>
        </div>
      </div>
    </div>

    <div class="zitcolor " style="background: #F9F9F9;padding-bottom: 72px;padding-top: 50px; box-sizing: border-box;">
      <div style="width: 1200px;margin: 0 auto;">
        <el-row>
          <el-col :span="24">
            <h1>合作伙伴</h1>
            <p style="color:#666;font-size: 16px;">Cooperative partner</p>
            <div class="Cooperative wow pulse" style="visibility: visible">
              <img src="../../assets/images/abfriend.png">
              <!--<img src="../../assets/images/About/WJ.png">
              <img src="../../assets/images/About/KC.png">
              <img src="../../assets/images/About/GJDW.png">
              <img src="../../assets/images/About/GKNY.png">
              <img src="../../assets/images/About/ZGH.png">
              <img src="../../assets/images/About/DTANG.png">
              <img src="../../assets/images/About/DT.png">
              <img src="../../assets/images/About/HY.png">
              <img src="../../assets/images/About/ZGHN.png">
              <img src="../../assets/images/About/NFDW.png">
              <img src="../../assets/images/About/ZGYQ.png">
              <img src="../../assets/images/About/JLYH.png">
              <img src="../../assets/images/About/ZA.png">
              <img src="../../assets/images/About/SXDQ.png">
              <img src="../../assets/images/About/XS.png">
              <img src="../../assets/images/About/DLGJ.png">
              <img src="../../assets/images/About/skf.png">
              <img src="../../assets/images/About/LLSTHJT.png">
              <img src="../../assets/images/About/ZGHSJ.png">
              <img src="../../assets/images/About/XGKS.png">-->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <advice/>
  </div>
</template>

<script>
import { bannerlist } from '@/api/projectSquare/xmgc'
import advice from '@/components/xmgc/ZXJY'
export default {
  name: "aboutUs",
  data() {
    return {
      show: false,
      class: 'bancreh wow flipInY',
      downloadUrl: process.env.API_ROOT.substr(0, process.env.API_ROOT.length - 1),
      // downloadUrl: 'http://113.246.243.106:12070',
      imagesbox: [],
      bannerHeight: null, // 轮播高度
      // imagesbox: [
      //   {
      //     id: 0,
      //     idView: require("../../assets/images/About/xinbannner.png")
      //   },{
      //     id: 1,
      //     idView: require("../../assets/images/bannertu/banner4.png")
      //   },{
      //     id: 2,
      //     idView: require("../../assets/images/bannertu/banner5.png")
      //   },

      // ],
    }
  },
  components:{
    advice
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        live: false
      }).init()
    });

  },

  created() {
    this.getbannerimg('?type=1'); // 更换参数获取不同的banner值   字典banner_type
    this.windowSrollListener()
  },


  methods: {
    windowSrollListener(){
      // 首次加载时,初始化高度
      let screenWidth = window.innerWidth
      this.bannerHeight = 533 / 1550 * screenWidth
      // 窗口大小发生改变
      window.onresize = () => {
        screenWidth = window.innerWidth
        this.bannerHeight = 533 / 1550 * screenWidth
      }
    },
    // 获取轮播图
    getbannerimg(type) {
      bannerlist(type).then(res => {
        this.imagesbox = res.data;
      }).catch(res => { })
    },
    // 点击轮播图某一个或者按需 跳转至对应的页面
    isLetgodeta(item) {
      let tourl = this.ifnull(item.toUrl);
      if (tourl) {
        this.$router.push(item.toUrl);
      }
    },
    // 判断是否为空 返回 false  true
    ifnull(status) {
      if (status === '' || status === null || status === undefined) {
        return false
      } else {
        return true
      }
    }
  }
};
</script>

<style scoped>
.imgtransion {
  cursor: pointer;
  transition: all 0.6s;
}

.imgtransion:hover {
  transform: scale(1.4);
}

.Platform-1 {
  margin-top: 20px;
}

.neirdier {
  width: 100%;
  margin-top: 56px;
  padding-bottom: 65px;
  background: url(../../assets/images/About/xinbg.png)no-repeat;
}

.gtfzys {
  margin-top: 144px;
  font-size: 32px !important;
  font-weight: 800;
  color: #333333;
  margin-bottom: 94px;
}

.bancreh {
  margin-top: 87px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
}

.bancreh .zitdxs {
  color: #333333;
  font-size: 30px;
  font-weight: bold;
  margin-top: 38px;
}

.aboustdw {
  width: 100%;
  text-align: center;
  /*  position: absolute;
   bottom: -91px;*/
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}

.bancreh-1 {
  position: relative;
  width: 380px;
  height: 442px;
  /*background: url(../../assets/images/About/xin1.png) no-repeat;*/
}

.bancreh-2 {
  position: relative;
  width: 380px;
  height: 442px;
  /* background: url(../../assets/images/About/xinjj.png) no-repeat;*/
}

.bancreh-3 {
  position: relative;
  width: 380px;
  height: 442px;
  /*  background: url(../../assets/images/About/xinst.png) no-repeat;*/
}

.fujaieindai {
  height: 428px;
  width: 395px;
  position: relative;
}

.mebanys {
  z-index: 10;
  text-align: center;
  width: 100%;
  height: 428px;
  position: absolute;
  top: 0;
  left: 0;
}

.spherechind {
  cursor: pointer;
  transition: 0.6s all;
  background-color: rgba(255, 255, 255, 0.3);
  filter: blur(0px);
  height: 428px;
  width: 395px;
  /* border: 1px solid #A0CFFF; */
}

.fujaieindai:hover+.spherechind {
  background-color: rgba(255, 255, 255, 0.3);
  filter: blur(2px);
}

.Jjfanga {
  background: url(../../assets/images/About/01.png);
}

.rjkf {
  background: url(../../assets/images/About/02.png);
}

.fwfa {
  background: url(../../assets/images/About/03.png);
}


.zitcolor {
  color: #333;

}

.zitcolor h1 {
  font-size: 40px;
  margin-top: 0;
}

.zitcolor h2 {
  font-size: 56px;
  font-family: 'Helvetica Neue'
}

.zitcolor p {
  font-size: 18px;

}

.official {
  margin-top: 56px;
  line-height: 40px;
}

.official p {
  text-align: left;
  font-size: 18px;
}

.sphere {
  /* border: 1px solid #00FFFF; */
  width: 100%;
  height: 430px;
  display: flex;
  justify-content: space-around;
}



.Platform {
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
  text-align: left;
}

.Platform h2 {
  font-size: 36px;
}

.Platform h3 {
  font-size: 30px;
}

.Platform p {
  color: #666;
}

.Cooperative {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 50px;
}

.Cooperative img {
  margin-top: 20px;
  width: 100%;
  margin-bottom: 22px;
}

.image {
  width: 100%;
  height: inherit;
}

/* 指示灯 */

.el-carousel .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel .el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

/* // 指示器 */
/* // 指示器按钮 */
.el-carousel /deep/ .el-carousel__button {
  width: 10px;
  height: 10px;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
}

/* // 指示器激活按钮 */
.el-carousel /deep/ .is-active .el-carousel__button {
  background: #F9B600;
}</style>



// WEBPACK FOOTER //
// src/components/AboutUs/index.vue